import {createSlice} from '@reduxjs/toolkit';

export interface AuthState {
  daily: any;
  allDailies: any;
}

const initialState: AuthState = {
  daily: {},
  allDailies: []
};

export const dailySlice = createSlice({
  name: 'daily',
  initialState,
  reducers: {
    daily: (state, {payload}) => {
      state.daily = payload;
    },
    saveDaily: (state, {payload}) => {
      state.daily = payload;
    }
  }
});

export const {daily} = dailySlice.actions;

export default dailySlice.reducer;
